import React from 'react'
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import { Box } from "@mui/material"
import { useCreateUsersModal } from "Pages/Admin/Users/@hooks"


export default function AdminUsersTableToolbar() {
	const { onOpenModal } = useCreateUsersModal()

	return <Box sx={{ my: 1, display: 'flex', gap: 2 }}>
		<ButtonLoadingSeeker
			startIcon={<IconSeeker icon="plus"/>}
			onClick={() => onOpenModal()}
		>
			Create User
		</ButtonLoadingSeeker>
	</Box>
}